import AgeGenderPanel from './ageGenderPanel.component';

export default AgeGenderPanel;